import { Badge, type BadgeVariant } from '@zyxantech/tux'

function variantFor(status: string): BadgeVariant {
  switch (status.toLowerCase()) {
    case 'completed':
      return 'success'
    case 'failed':
      return 'danger'
    case 'running':
      return 'info'
    default:
      return 'default'
  }
}

export function ReportStatusBadge({ status }: { status: string }) {
  return <Badge variant={variantFor(status)}>{status}</Badge>
}
